import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeInit"] */ "/app/src/components/theme-init.tsx");
